const base =
  (process.env.REACT_APP_BACKEND_URL || "").replace(/\/$/, "") + "/api";
export async function api(path, body, method) {
  const response = await fetch(base + path, {
    method: method || (body === undefined ? "GET" : "POST"),
    credentials: "include",
    headers: {
      "Content-Type": "application/json",
      ...(localStorage.getItem("token")
        ? { Authorization: `Bearer ${localStorage.getItem("token")}` }
        : {}),
    },
    ...(body === undefined ? {} : { body: JSON.stringify(body) }),
  });
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(
      typeof data.detail === "string"
        ? data.detail
        : data.detail?.error ||
          `No se pudo completar la operación (${response.status})`,
    );
    error.status = response.status;
    error.requiresReview = data.detail?.requires_review === true;
    error.operationId = data.detail?.operation_id;
    throw error;
  }
  return data;
}
export const money = (amount, currency = "MXN") =>
  amount == null
    ? "Sin verificar"
    : new Intl.NumberFormat("es-MX", {
        style: "currency",
        currency: currency.toUpperCase(),
      }).format(amount);
export const date = (value) =>
  value
    ? new Date(value).toLocaleString("es-MX", {
        timeZone: "America/Mexico_City",
      })
    : "Sin datos";
